import type { SelectDropdownRenderOptions } from "./select-dropdown.type";
import type { ReactNode } from "react";

import { SelectDropdownMultiline } from "./select-dropdown-multiline";

export const getSelectDropdownRender = ({
  multilineOptions,
}: SelectDropdownRenderOptions = {}) => {
  if (multilineOptions) {
    // See `popupRender` props from Ant Design `Select` https://ant.design/components/select#api
    // https://ant.design/components/select#select-demo-custom-dropdown-menu
    const popupRender = (dropdownNode: ReactNode) => (
      <SelectDropdownMultiline
        dropdownNode={dropdownNode}
        multilineOptions={multilineOptions}
      />
    );
    return popupRender;
  }

  return undefined;
};
